/** Management pages stay on Atrivial; player routes, including guest profiles, remain embeddable. */
export const ACCOUNT_ROUTE_PATH_PATTERN =
  '^/(?:portal|dashboard|partner-portal|sign-in|sign-up|auth|integrations/kit|subscription-confirmation|edit-daily-challenge)(?:/|$)';
const accountRoute = new RegExp(ACCOUNT_ROUTE_PATH_PATTERN, 'i');

export function isAccountRoutePathname(pathname) {
  // Match Router and nginx when a path segment uses percent encoding.
  try {
    return accountRoute.test(decodeURIComponent(pathname));
  } catch {
    return accountRoute.test(pathname);
  }
}

/** Match frame-ancestors 'self', including same-origin frames nested below another site. */
export function hasExternalFrameAncestor() {
  if (typeof window === 'undefined') return false;
  try {
    const origin = window.location.origin;
    let ancestor = window.parent;
    while (ancestor !== window) {
      if (ancestor.location.origin !== origin) return true;
      if (ancestor.parent === ancestor) return false;
      ancestor = ancestor.parent;
    }
    return false;
  } catch {
    // Browsers deny location access for cross-origin and opaque-origin ancestors.
    return true;
  }
}
